export * from "./rx_tab_content_control_directive";
export * from "./rx_tab_control_directive";
export * from "./rx_tabs_control_directive";
export * from "./portal_host_control_directive";
export * from "./tab.models";

export * from "./rx_tab_content_control_component";
export * from "./rx_tab_control_component";
export * from "./rx_tabs_control_component";


// WEBPACK FOOTER //
// ./node_modules/@rx/view/tab/tabs.ts